module.exports = __webpack_public_path__ + "img/ex.a392cf99.png";